import { render, staticRenderFns } from "./apiDetailList.vue?vue&type=template&id=08852799"
import script from "./apiDetailList.vue?vue&type=script&lang=js"
export * from "./apiDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.33_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_a4ajn4nredche26m3ww6ixpcm4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports